// State used by multiple vue apps

export const sharedData = {
  str: "",
  cookieNameCart: "cart_items",
  cart: [],
  isFavorite: false
};
